// extracted by mini-css-extract-plugin
export default {"root":"SectionStats_root__PZrHm","point":"SectionStats_point__CqqP3","figure":"SectionStats_figure__LEPr6","text":"SectionStats_text__Ee8Eb"};